<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="headTitle"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">{{ headTitle }}</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="input_div">
                <p>排序</p>
                <el-input
                  @mousewheel.native.prevent
                  @DOMMouseScroll.native.prevent
                  class="input"
                  type="number"
                  onkeyup="value=value.replace(/\D/g,'')"
                  placeholder="请输入"
                  v-model="info.order"
                ></el-input>
              </div>
              <div class="input_div">
                <p>福利名称</p>
                <el-input
                  class="input"
                  v-model="info.title"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div class="input_div">
                <p>状态</p>
                <el-select
                  class="input"
                  v-model="info.status"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in openOptions"
                    :key="item.value"
                    :value="item.value"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>福利图标</p>
                <input
                  type="file"
                  accept="image/*"
                  style="display: none"
                  id="uploadfile"
                  @change="openFolder"
                />
                <el-button size="mini" @click="openImage()"
                  >选择本地图片</el-button
                >
                <el-image class="imageDiv" :src="imageUrl" fit="scale-down">
                  <div
                    slot="error"
                    class="image-slot"
                    style="position: absolute; top: 50%; left: 50%"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <!-- <div v-if="info.type != 'function'"> -->
              <div style="clear: both"></div>
              <div
                class="input_div"
                v-if="info.type == 'details' || info.type == 'rich_text'"
              >
                <p>详情类型</p>
                <el-select
                  style="width: 100%"
                  v-model="info.type"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in detailsTypesOptions"
                    :key="item.en"
                    :value="item.en"
                    :label="item.cn"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="input_div"
                v-if="info.type == 'function' || info.type == 'rich_text'"
              >
                <p>问卷</p>
                <el-select
                  style="width: 100%"
                  v-model="info.survey_id"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in paramSurveyLis"
                    :key="item.survey_id"
                    :value="item.survey_id"
                    :label="item.title"
                  ></el-option>
                </el-select>
              </div>
              <div class="input_div" v-if="info.type == 'details'">
                <p>推文链接</p>
                <el-input
                  class="input"
                  v-model="info.details"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div
                class="input_div"
                v-if="info.type == 'rich_text' || info.id == 1"
                style="width: 100%"
              >
                <p>文本编辑器</p>
                <VueUeditorWrap
                  :destroy="true"
                  v-model="info.rich_text"
                  :config="editorConfig"
                />
              </div>
              <!-- </div> -->
            </div>
          </div>
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { URL_PATH, Editor_Config } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";
import FootLayout from "@/components/layout/footLayout";
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout,
    VueUeditorWrap
  },
  data() {
    return {
      meunItem: null,
      meunTitle: "",
      headTitle: "",
      urlPath: URL_PATH,
      info: { id: -1, order: "10000", type: "", survey_id: "" },
      openOptions: Constant.options_open, //是否启用
      detailsTypesOptions: Constant.details_types_filters,
      editorConfig: Editor_Config,
      imageUrl: "",
      paramSurveyLis: []
    };
  },
  methods: {
    initData(meunItem) {
      this.getParamSurveyLis();
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.infoId = this.$route.query.id;
      this.headTitle = this.infoId == null ? "新增校友福利" : "编辑校友福利";
      this.getInfo();
    },
    // 获取详情
    getInfo() {
      var id = this.$route.query.id;
      if (id == null) {
        this.info.type = "details";
        return;
      }
      this.$api
        .welfareInfo({
          token: localStorage.getItem("token"),
          id: id
        })
        .then(({ data }) => {
          if (data.Data.survey_id == null) {
            data.Data.survey_id = "";
          }
          this.info = data.Data;
          this.createTime = new Date(this.info.create_time * 1000);
          this.imageUrl = this.urlPath + this.info.icon;
        })
        .catch(({ error }) => {});
    },
    // 新增
    addInfo: function (form) {
      this.$api
        .updateWelfare(form)
        .then(({ data }) => {
          this.$message({
            message: "新建成功",
            type: "success"
          });
          this.$router.back(-1);
        })
        .catch(({ error }) => {});
    },
    // 编辑
    updateInfo: function (form) {
      form.append("id", this.info.id);
      this.$api
        .updateWelfare(form)
        .then(({ data }) => {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.$router.back(-1);
        })
        .catch(({ error }) => {});
    },
    // 选择图片
    openImage() {
      document.getElementById("uploadfile").click();
    },
    openFolder(e) {
      var that = this;
      var image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function (evt) {
        that.imageUrl = evt.target.result;
      };
      reader.readAsDataURL(image);
      this.info.icon = image;
    },
    // 保存
    saveEdit() {
      if (
        StrUtils.isEmpty(this.info.order) ||
        StrUtils.isEmpty(this.info.title) ||
        StrUtils.isEmpty(this.info.status) ||
        StrUtils.isEmpty(this.info.icon)
      ) {
        this.$message.error("请先完善数据");
        return;
      }
      var form = new FormData();
      // if (this.info.type != 'function') {
      form.append("type", this.info.type);
      if (this.info.type == "details") {
        if (StrUtils.isEmpty(this.info.details)) {
          this.$message.error("推文链接不能为空");
          return;
        } else {
          form.append("details", this.info.details);
        }
      }
      if (this.info.type == "rich_text" || this.info.id == 1) {
        if (StrUtils.isEmpty(this.info.rich_text)) {
          this.$message.error("文本编辑器不能为空");
          return;
        } else {
          form.append("rich_text", this.info.rich_text);
        }
      }
      // }

      form.append("token", localStorage.getItem("token"));
      form.append("order", this.info.order);
      form.append("title", this.info.title);
      form.append("status", this.info.status);
      form.append("icon", this.info.icon);
      form.append("survey_id", this.info.survey_id);
      // if (this.info.type != 'function') {
      //   form.append('details', this.info.details)
      // }
      if (this.infoId) {
        this.updateInfo(form);
      } else {
        this.addInfo(form);
      }
    },
    getParamSurveyLis() {
      this.$api
        .paramSurveyLis({ token: localStorage.getItem("token") })
        .then(({ data }) => {
          this.paramSurveyLis = data.Data;
          this.paramSurveyLis.unshift({ survey_id: "", title: "不启用" });
        })
        .catch(({ error }) => {});
    }
  }
};
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div .input {
  width: 100%;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
</style>

 <style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/welfareAdd.vue